import { Postcode } from './postcode';
import { DistributorProduct } from './distributor-product';
export class DistributorContractAreaPostcode
{
	id: number;
	postcode: Postcode;
	distributorProduct: DistributorProduct;
	price_per_thousand: number;
	total_amount: number;
	gross_amount: number;
	net_amount: number;
	walkday: string;
	valid: boolean;
	optin: boolean;
	saveable: boolean;

	constructor()
	{
		this.price_per_thousand = 0;
		this.total_amount = 0;
		this.gross_amount = 0;
		this.net_amount = 0;
		this.walkday= null;
		this.valid = true;
		this.optin = false;
		this.saveable = true;
	}
}



// WEBPACK FOOTER //
// ./src/app/models/distributor-contract-area-postcode.ts